<template>
  <div>
    <header-page></header-page>
    <div class="router-top">
      <router-view />
    </div>
  </div>
</template>
<script>
import HeaderPage from '@/pages/common/views/components/headnav/ipad/IpadHeadNav'
export default {
  name: 'Ipad',
  components: {
    HeaderPage,
  },
};
</script>
<style lang="less" scoped>
.router-top {
  padding-top:44px;
}
</style>
